import React from 'react';

export default function AjaxSpinner({show=true})
{
    return (
            <div className={show === true ? 'loader loader--visible' : 'loader'}></div>
    );
};